import React from 'react'
import { RadioVariant } from './../../../models/types/radio-variant';

interface RadioProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  variant?: RadioVariant,
  type?: "dot" | "tick",
  isActive?: boolean,
  description?: JSX.Element | string
  onClick?: () => void,
  gap?: number;
  disabled?: boolean;
}

const isVariantDefaultOrReverse = (variant?: RadioVariant) => {
  return (variant === "default" || variant === "reverse");
}

const getDisabled = (disabled: boolean) => {
    return disabled ? "disabled" : "";
}
function Radio({ gap = 10, type = "dot", variant = "default", isActive = false, disabled = false, ...props }: RadioProps) {

  return (
    <div className='polymer-radio-form' style={{ gap: gap, flexDirection: variant === "reverse" ? 'row-reverse' : undefined }}>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ flex: 0, alignSelf: "center" }}>
          <div onClick={()=>{
            if(props.onClick && !disabled){
              props.onClick();
            }
          }} className={`polymer-radio-form__icon 
            ${(isVariantDefaultOrReverse(variant)) && isActive && type === "dot" ? 'active' : getDisabled(disabled)} 
            ${(isVariantDefaultOrReverse(variant)) && isActive && type === "tick" ? 'active-tick' : getDisabled(disabled)}`}
          >

            {type === "dot" && (isVariantDefaultOrReverse(variant)) && isActive && <div className='polymer-radio-form__icon-active' />}

            {type === "tick" && (isVariantDefaultOrReverse(variant)) && isActive &&
              <div className='polymer-radio-form__icon-active-tick'>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>}

          </div>
        </div>
        {props.description && <div className='polymer-radio-form__description' >{props.description ? props.description : undefined}</div>}
      </div>
    </div>
  )
}

export default Radio